import React from 'react';
import BaseForm from '@its/components/lib/Container components/FormContainer/BaseForm';
import Circle from 'material-ui/svg-icons/av/fiber-manual-record';
import BorderedCircle from 'material-ui/svg-icons/image/panorama-fish-eye';
import {
  UserPermissionContainer,
} from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';
import {
  developer,
  admin,
} from '@its/components/lib/Container components/UserContainer/roles';
import {
  generalDataText,
  FieldNum,
  ExampleFieldNum,
  RowNum,
  ExampleRowNum,
  Width,
  ExampleWidth,
  AdapterNum,
  MultiCharacter,
  Sliding,
  Intermittence,
  Indicator,
} from '../../../i18n/intl';
import {
  cancelText,
  submitText,
  colorText,
  redText,
  yellowText,
  blueText,
  greenText,
  whiteText,
} from '@its/components/lib/util/i18n';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.config = {
      submitText,
      cancelText,
      groups: [
        {
          key: 'generalData',
          title: generalDataText,
          fields: {
            fieldNum: {
              hintText: ExampleFieldNum,
              floatingLabelText: FieldNum,
              validators: {
                type: 'number',
                required: true,
                max: 255,
              },
            },
            rowNum: {
              hintText: ExampleRowNum,
              floatingLabelText: RowNum,
              validators: {
                type: 'number',
                required: true,
                max: 255,
              },
            },
            width: {
              hintText: ExampleWidth,
              floatingLabelText: Width,
              validators: {
                type: 'number',
                required: true,
                max: 255,
              },
            },
            adapterNum: {
              type: 'select',
              floatingLabelText: AdapterNum,
              newLine: true,
              items: [{
                primaryText: '1',
                value: 1,
              }, {
                primaryText: '2',
                value: 2,
              }],
              validators: {
                required: true,
              },
            },
            color: {
              type: 'select',
              floatingLabelText: colorText,
              items: [{
                primaryText: redText,
                value: '#FF3D00',
                leftIcon: <Circle style={ { fill: '#FF3D00' } } />,
              }, {
                primaryText: yellowText,
                value: '#F9EF00',
                leftIcon: <Circle style={ { fill: '#F9EF00' } } />,
              }, {
                primaryText: blueText,
                value: '#00B0FF',
                leftIcon: <Circle style={ { fill: '#00B0FF' } } />,
              }, {
                primaryText: greenText,
                value: '#64DD17',
                leftIcon: <Circle style={ { fill: '#64DD17' } } />,
              }, {
                primaryText: whiteText,
                value: '#FFFFFF',
                leftIcon: <BorderedCircle />,
                style: {
                  boxShadow: '5px',
                },
              }],
              validators: {
                required: true,
              },
            },
            multiCharacter: {
              type: 'checkbox',
              label: MultiCharacter,
              newLine: true,
            },
            sliding: {
              type: 'checkbox',
              label: Sliding,
              newLine: true,
            },
            intermittence: {
              type: 'checkbox',
              label: Intermittence,
              newLine: true,
            },
            indicator: {
              type: 'checkbox',
              label: Indicator,
              newLine: true,
            },
          },
        },
      ],
    };
  }

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin]}
        showError
      >
        <BaseForm
          config={this.config}
          {...this.props}
        />
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Template/Map/MapForm.js
 **/